const directionpages = [
  {
    path: '/directions',
    name: 'directions',
    component: () => import('@/views/directions/Direction.vue'),
    meta: {
      layout: 'content',
      title: 'Directions',
    },
  },
 /* {
    path: '/directions/:id/show',
    name: 'showdirection',
    component: () => import('@/views/directions/DirectionDetails.vue'),
    meta: {
      layout: 'content',
      title: "Détails d'un direction",
    },
  },*/
]

export default directionpages
